import { HStack, VStack, Text, Tooltip, Icon, Box } from '@chakra-ui/react';
import { Info } from 'lucide-react';
import { iconSize } from '@duke-hq/ui/constants/scalable';

export default function Section({
  title,
  tooltipText,
  children,
}: {
  title: string;
  tooltipText: string;
  children: React.ReactNode;
}) {
  return (
    <VStack gap="2.5" w="full" alignItems="flex-start">
      <HStack w="full" gap="1" alignItems="top">
        <Text
          fontSize="lg"
          fontWeight="semibold"
          color="fg.emphasis"
          lineHeight="7"
          letterSpacing="0%"
          verticalAlign="middle"
        >
          {title}
        </Text>
        <Box mt="0.5">
          <Tooltip
            label={tooltipText}
            fontSize="xs"
            fontWeight="medium"
            placement="top"
            shadow="none"
            hasArrow
            bg="bg.subtle"
            borderRadius="sm"
            border="1px"
            borderColor="border.emphasis"
            color="fg.default"
            sx={{
              '& .chakra-tooltip__arrow': {
                marginTop: '2px',
                borderBottom: '1px ',
                borderRight: '1px ',
                borderColor: 'border.emphasis',
              },
            }}
          >
            <Icon as={Info} color="fg.muted" boxSize={iconSize.xs} />
          </Tooltip>
        </Box>
      </HStack>
      <HStack w="full" justifyContent="flex-start">
        {children}
      </HStack>
    </VStack>
  );
}
